import $ from 'jquery';
$(function () {
  var $b2t = $('.back-to-top');
  var $floatingISI = $('.floating-isi');
  var $isi = $('.isi');
  var $isiDeepLink = $('#isi');
  var $isiToggle = $('.js-isi-toggle');
  var $isiToggleViewAll = $('.js-isi-view-all');
  var $window = $(window);
  var isiHide = false;
  if (!$floatingISI || !$floatingISI.length) {
    return;
  }
  $isiToggle.on('click touchend', expandFloatingISI);
  $isiToggleViewAll.on('click touchend', scrollToISI);
  $window.on('load', checkScroll);
  $window.on('scroll', checkScroll);
  function checkScroll() {
    var footerHeight = $('footer').height();
    var top_of_object = $isi.offset().top;
    var bottom_of_object = $isi.offset().top + $isi.outerHeight() + footerHeight;
    var top_of_window = $window.scrollTop();
    var bottom_of_window = $window.scrollTop() + $window.height();
    var sticky_isi_offset = 130;
    if (top_of_window <= bottom_of_object && bottom_of_window >= top_of_object + sticky_isi_offset) {
      if (!isiHide) {
        isiHide = true;
        $floatingISI.fadeOut(250);
        $b2t.addClass('active');
      }
      if ($floatingISI.hasClass('fixed')) {
        $floatingISI.removeClass('fixed');
        $floatingISI.fadeOut(250);
        $b2t.addClass('active');
      }
    } else {
      if (!$floatingISI.hasClass('fixed')) {
        $floatingISI.addClass('fixed');
        $floatingISI.fadeIn(250);
        $b2t.removeClass('active');
      }
    }
  }
  function expandFloatingISI(event) {
    event.preventDefault();
    $floatingISI.attr('aria-expanded', function (i, attr) {
      return attr === 'true' ? 'false' : 'true';
    });
  }
  function scrollToISI() {
    var scrollTop = $isiDeepLink.offset().top;
    $('html, body').animate({
      scrollTop: scrollTop
    }, 'fast');
  }
});